module.exports = __webpack_public_path__ + "static/slide3-hybrid-workplace-beaf76599fc57989d8eaf47554153646.jpg";